import { detectDiagramType } from './detect.js';
import { parseFlowchart } from './parsers/flowchart.js';
import { parseSequence } from './parsers/sequence.js';
import { parseClassDiagram } from './parsers/class.js';
import { parseStateDiagram } from './parsers/state.js';
import { parseErDiagram } from './parsers/er.js';
import { parseGantt } from './parsers/gantt.js';
import { parseC4 } from './parsers/c4.js';
import { parseJourney } from './parsers/journey.js';
import { parseRequirement } from './parsers/requirement.js';
import { parseMindmap } from './parsers/mindmap.js';
import { parseGeneric } from './parsers/generic.js';
import { renderToCanvas } from './render.js';
export const convertMermaidInternal = (code, _options = {}) => {
    const type = detectDiagramType(code);
    const model = parseDiagram(code, type);
    const { elements, bounds } = renderToCanvas(model);
    const source = {
        id: `ms_${Date.now().toString(36)}`,
        code,
        diagramType: model.type,
        createdAt: new Date().toISOString(),
        bounds,
        nodeMap: buildNodeMap(model),
        edgeMap: buildEdgeMap(model),
    };
    return { elements, mermaidSource: source, model };
};
const buildNodeMap = (model) => {
    const map = {};
    for (const n of model.nodes) {
        const el = renderToCanvas(model).elements.find((e) => e.mermaidId === n.id);
        if (el)
            map[n.id] = el.id;
    }
    return map;
};
const buildEdgeMap = (model) => {
    const map = {};
    let i = 0;
    for (const e of model.edges) {
        map[e.id] = `cn_${Date.now().toString(36)}_${i++}`;
    }
    return map;
};
const parseDiagram = (code, type) => {
    switch (type) {
        case 'flowchart':
            return parseFlowchart(code);
        case 'sequence':
            return parseSequence(code);
        case 'class':
            return parseClassDiagram(code);
        case 'state':
            return parseStateDiagram(code);
        case 'er':
            return parseErDiagram(code);
        case 'gantt':
            return parseGantt(code);
        case 'c4Context':
        case 'c4Container':
        case 'c4Component':
        case 'c4Dynamic':
        case 'c4Deployment':
            return parseC4(code, type);
        case 'journey':
            return parseJourney(code);
        case 'requirement':
            return parseRequirement(code);
        case 'mindmap':
            return parseMindmap(code);
        default:
            return parseGeneric(code, type);
    }
};
export const convertMermaid = async (code, options) => {
    const { elements, mermaidSource } = convertMermaidInternal(code, options);
    return { elements, mermaidSource };
};
//# sourceMappingURL=index.js.map